<div class="body-padding" id="assets-page">
  <div class="flex flex-col items-baseline mb-4">
    <h1 class="general-font text-4xl font-bold text-gray-900 dark:text-gray-100" id="assets-title">Assets</h1>
  </div>
  <div [formGroup]="filterForm" class="filter-form">
    <div class="flex flex-wrap gap-x-7 gap-y-4">
      <div class="w-fit">
        <label for="assets-search-input"
               class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-100">Search</label>
        <div id="assets-search-container"
             class="flex items-center h-[36px] border border-gray-300 dark:border-gray-600 rounded-md bg-gray-50 dark:bg-gray-700">
          <svg class="ml-2 h-5 w-5 pr-1 text-gray-600 dark:text-gray-300" width="15" height="16" viewBox="0 0 15 16"
               fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <g id="Left Icon">
              <path id="Vector"
                    d="M14.5 15L10.5 11M6.5 13C3.18629 13 0.5 10.3137 0.5 7C0.5 3.68629 3.18629 1 6.5 1C9.81371 1 12.5 3.68629 12.5 7C12.5 10.3137 9.81371 13 6.5 13Z"
                    stroke="currentColor"/>
            </g>
          </svg>
          <input id="assets-search-input" formControlName="assetLookup" type="text"
                 placeholder="Assets Lookup" class="input-custom h-full py-0"/>
        </div>
      </div>
      <div class="w-fit">
        <label for="assets-location-select" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-100">
          Location
        </label>
        <ng-select id="assets-location-select"
                   [items]="locations"
                   formControlName="location"
                   bindValue="location_id"
                   bindLabel="location_name"
                   placeholder="Location Lookup"
                   [clearable]="isSelectClearable('location')"
                   (clear)="clearSelectValue('location')"
                   notFoundText="No location found">
          <ng-template ng-label-tmp let-item="item">
            <p [class.text-gray-500]="item.location_id === 0">{{ item.location_name }}</p>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <p>{{ item.location_name }}</p>
            @if (item.full_address) {
              <p class="opacity-50">{{ item.full_address }}</p>
            }
          </ng-template>
        </ng-select>
      </div>

      <div class="relative" (clickOutside)="closeExportDropdown()">
        <label for="assets-export-btn"
               class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-100 opacity-0">
          Export
        </label>
        <button id="assets-export-btn"
                class="flex gap-2 items-center bg-gray-50 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-100 rounded-md px-4 h-[36px] focus:ring-2 focus:outline-none hover:bg-gray-100 dark:hover:bg-gray-600"
                type="button"
                (click)="toggleExportDropdown()">
          Export
          <svg class="w-5 h-5 text-gray-800 dark:text-gray-200" aria-hidden="true"
               xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 10V4a1 1 0 0 0-1-1H9.914a1 1 0 0 0-.707.293L5.293 7.207A1 1 0 0 0 5 7.914V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2M10 3v4a1 1 0 0 1-1 1H5m5 6h9m0 0-2-2m2 2-2 2"/>
          </svg>
        </button>
        @if (isExportDropdownOpen) {
          <div id="assets-export-dropdown"
               class="absolute right-0 mt-2 bg-white dark:bg-gray-800 divide-y divide-gray-100 dark:divide-gray-700 rounded-lg shadow w-48">
            @if (currentUser.is_owner == 0 && currentUser.is_rentee == 1) {
              <ul class="py-2 text-sm text-gray-700">
                <li id="rental-assets-export-csv" (click)="handleExport('rental', 'csv')" class="export-button">
                  Export to CSV
                </li>
                <li id="rental-assets-export-excel" (click)="handleExport('rental', 'excel')" class="export-button">
                  Export to Excel
                </li>
              </ul>
            }
            @if (currentUser.is_owner == 1) {
              <ul class="py-2 text-sm text-gray-700">
                <li id="assets-export-csv" (click)="handleExport('asset', 'csv')" class="export-button">Export to CSV
                </li>
                <li id="assets-export-excel" (click)="handleExport('asset', 'excel')" class="export-button">Export to
                  Excel
                </li>
              </ul>
            }
          </div>
        }
      </div>
      @if (currentUser.is_owner == 1 && currentUser.is_rentee == 0) {
        <!-- Placeholder for the Show Inactive toggle -->
        <div class="opacity-0">
          <label class="block mb-2 text-sm font-medium">Placeholder</label>
          <div class="flex gap-3">
            <div class="min-w-11 h-6"></div>
            <span class="text-sm font-medium whitespace-nowrap">Show Inactive</span>
          </div>
        </div>
      }
    </div>

    @if (currentUser.is_owner == 1 && currentUser.is_rentee == 0) {
      <div class="absolute bottom-0 right-0">
        <label class="inline-flex items-center cursor-pointer">
          <input id="assets-show-inactive-toggle" type="checkbox" formControlName="showInactive" class="sr-only peer">
          <div
            class="relative min-w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
          <span class="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">Show Inactive</span>
        </label>
      </div>
    }
  </div>

  <div>
    <ul class="flex gap-2 flex-wrap -mb-px text-lg font-medium text-center" id="assets-tabs" role="tablist">
      @if (currentUser.is_owner == 0 && currentUser.is_rentee == 1) {
        <li>
          <button class="tab-button" [class.selected-tab-button]="activeTab === 'rentedAssets'"
                  (click)="changeTab('rentedAssets')">
            Rented Assets
          </button>
        </li>
      }
      @if (currentUser.is_owner == 1) {
        <li>
          <button class="tab-button" [class.selected-tab-button]="activeTab === 'myAssets'"
                  (click)="changeTab('myAssets')">
            My Assets
          </button>
        </li>
      }
    </ul>

    @if (activeTab === 'myAssets') {
      <custom-table id="assets-table" [columns]="assetsTableColumns()" [data]="assetsTableData"
                    primaryDataKey="asset_id" [actions]="assetsTableActions" [serverPagination]="true"
                    [(currentPage)]="assetsCurrentPage" [loading]="loadingAssetTableData()"
                    (paramsChange)="onAssetsTableParamChange($event)"
                    emptyDataMessage="No Assets matching your filters"/>
    }
    @if (activeTab === 'rentedAssets') {
      <custom-table id="assets-table-rental" [columns]="rentalTableColumns()" [data]="rentalTableData"
                    primaryDataKey="asset_id" [serverPagination]="true" [(currentPage)]="rentalCurrentPage"
                    [loading]="loadingRentalTableData()" (paramsChange)="onRentalTableParamChange($event)"
                    emptyDataMessage="No Assets matching your filters"/>
    }
    <ng-template #serialNumberAssetColumn let-row>
      <div class="p-2">
        <span class="font-bold rounded cursor-pointer hover:bg-gray-200 hover:ring-8 hover:ring-gray-200"
              [ngClass]="row['is_active'] ? 'text-black' : 'text-red-600'"
              (click)="openAssetDetails(row)">
          {{ row[AssetTableColumn.SerialNumber] }}
        </span>
      </div>
    </ng-template>
    <ng-template #serialNumberRentalColumn let-row>
      <div class="p-2">
        <span class="font-bold rounded cursor-pointer hover:bg-gray-200 hover:ring-8 hover:ring-gray-200"
              (click)="openAssetDetails(row)">
          {{ row[RentalAssetTableColumn.SerialNumber] }}
        </span>
      </div>
    </ng-template>
    <ng-template #nextPmColumn let-row>
      <span class="whitespace-nowrap"
            [ngStyle]="{ 'color': row[AssetTableColumn.NextPmStatusColor] }">
        {{ row[AssetTableColumn.NextPm] }}
      </span>
    </ng-template>
  </div>
</div>

@if (showDetailsModal) {
  <div id="assets-details-popup"
       class="overflow-y-auto pt-4 border-t pb border-gray-200 fixed top-[0px] right-0 z-40 pb-10 h-full shadow-xl p-4 bg-white w-1/2">
    <div class="flex justify-between">
      <h5 id="assets-details-title"
          class="general-font text-2xl font-semibold text-gray-700 uppercase">
        Asset #{{ detailsSerialNumber ?? '' }}
      </h5>
      <button id="assets-details-close-btn" (click)="closeAssetDetails()" type="button"
              class="flex items-center justify-center text-gray-400 text-sm w-8 h-8 bg-transparent rounded-lg hover:bg-gray-200 hover:text-gray-900">
        <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
        </svg>
        <span class="general-font sr-only">Close menu</span>
      </button>
    </div>
    <div class="mt-4">
      <custom-table id="assets-details-history-table" [columns]="detailsTableColumns()" [data]="detailsTableData()"
                    primaryDataKey="job_id" [loading]="loadingDetailsTableData()" [usePagination]="false"
                    emptyDataMessage="No Jobs for this asset" [clickableRows]="true"
                    (rowClick)="onDetailsRowClick($event)"/>
    </div>
  </div>
}

@if (isGeneratingReport && currentFileType) {
  <loading-overlay [message]="'Please wait while we are generating ' + currentFileType.toUpperCase() + ' document'"/>
}

@if (relocatingAsset != null) {
  <confirm-modal id="assets-relocate-popup"
                 headerText="Move Asset to a Different Location"
                 (confirm)="onRelocateConfirmed()"
                 (cancel)="onRelocateCanceled()"
                 confirmText="Move Asset">
    <label for="assets-relocate-location-select" class="block mb-2 text-sm font-medium text-gray-900">
      New Location
    </label>
    <ng-select id="assets-relocate-location-select"
               class="min-w-full"
               [items]="relocateLocations"
               [(ngModel)]="relocateLocationId"
               bindValue="location_id"
               bindLabel="location_name"
               placeholder="Select a location"
               notFoundText="No location found">
      <ng-template ng-option-tmp let-item="item">
        <p>{{ item.location_name }}</p>
        @if (item.full_address) {
          <p class="opacity-50">{{ item.full_address }}</p>
        }
      </ng-template>
    </ng-select>
    @if (relocatingAsset.has_open_jobs) {
      <div id="assets-relocate-open-jobs-warning"
           class="mt-4 p-3 rounded-md bg-amber-50 border border-amber-300 text-amber-800 text-sm">
        <p><b>Note:</b> This asset has a job(s) in progress. Regardless of where you move the asset, this asset will
          still be shipped to its original location. Please email
          <a [href]="'mailto:' + serviceTeamEmail" class="underline">{{ serviceTeamEmail }}</a>
          if you need to update the shipping address for this asset.</p>
      </div>
    }
  </confirm-modal>
}

@if (activationSwitchingAsset != null) {
  <confirm-modal id="assets-confirm-popup"
                 [headerText]="'Are you sure you want to ' + (activationSwitchingAsset.is_active ? 'deactivate' : 'activate') + ' this Asset?'"
                 (confirm)="onActivationSwitchConfirmed()"
                 (cancel)="onActivationSwitchCanceled()"
                 [confirmText]="activationSwitchingAsset.is_active ? 'Deactivate' : 'Activate'"
                 [confirmColor]="activationSwitchingAsset.is_active ? '#91231C' : '#1F6D5F'">
    @if (activationSwitchingAsset.is_active) {
      <p>You will no longer receive notifications for upcoming or overdue preventive maintenance (PM) for this asset. To
        start receiving notifications again, reactivate the asset by selecting 'Activate' from the three-dot menu.</p>
    }
  </confirm-modal>
}
